import { Box } from '@mui/material'
import React from 'react'

export default function SupLoading() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '70vh' }}>
      <div class="spinner"></div>
    </Box>
  )
}
